import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { PresenceSettingsQuery } from './presence/PresenceSettingsQuery.graphql.ts';
import type {
	PresenceSettingsQuery as PresenceSettingsQueryType,
	PresenceSettingsQueryVariables,
} from './presence/__types__/PresenceSettingsQuery.ts';

export function preloadPresenceSettings({
	cloudId,
	spaceKey,
}: {
	cloudId: string;
	spaceKey: string;
}) {
	return query<PresenceSettingsQueryType, PresenceSettingsQueryVariables>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: PresenceSettingsQuery,
		variables: {
			cloudId,
			spaceKey,
		},
	});
}
